// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper[data-v-50f5df66]{display:grid;grid-gap:10px;align-items:center;grid-template-columns:min-content auto;grid-auto-flow:column}a[data-v-50f5df66]{//text-decoration:underline;//color:#80bd1c}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
